import { isEmpty } from 'lodash';
import { uuid } from '../../shared/uuid';

export function mergeColorRecipes(
  current,
  additions,
  uuidMaker: uuid.PrefixUuidFunc
) {
  current = current || {};
  additions = additions || {};

  const _additions = Object.keys(additions).reduce(
    (acc, key) => {
      const newKey = uuidMaker(`color-recipe-${key}`);
      acc.newColorRecipeIds[key] = newKey;
      acc.colorRecipes[newKey] = additions[key];
      return acc;
    },
    {
      colorRecipes: {},
      newColorRecipeIds: {}
    }
  );

  return {
    colorRecipes: { ...current, ..._additions.colorRecipes },
    newColorRecipeIds: _additions.newColorRecipeIds
  };
}

export function updateChapterColorRecipes(
  newChapters,
  newColorRecipeIds
): any[] {
  return newChapters.map(chapter => {
    // does this chapter have color recipes?
    if (isEmpty(chapter.colorRecipeObjects)) {
      return chapter;
    }

    // for each color recipe key, replace it
    const colorRecipes = Object.keys(chapter.colorRecipeObjects).reduce(
      (acc, key) => {
        const newKey = newColorRecipeIds[key];
        acc[newKey] = chapter.colorRecipeObjects[key];
        return acc;
      },
      {}
    );
    chapter.colorRecipeObjects = colorRecipes;
    return chapter;
  });
}
